export default __webpack_public_path__ + "static/media/lecture-strike.5dbcf27c.png";